import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const CONSENT_KEY = "hb_cookie_consent";
const GA4_ID = "G-852JDNXHP5";

function loadGA4() {
  if (window.__ga4Loaded) return;
  window.__ga4Loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID);
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { lang } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      loadGA4();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    loadGA4();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-hb-dark border-t border-white/10"
      style={{ boxShadow: "0 -4px 32px rgba(0,0,0,0.4)" }}
    >
      <div className="container-hb py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <div className="flex-1 pr-4">
          <p className="text-xs text-white/40 tracking-widest uppercase font-semibold mb-1">
            {lang === 'it' ? 'Privacy' : 'Datenschutz'}
          </p>
          <p className="text-sm text-white/70 font-inter leading-relaxed">
            {lang === 'it'
              ? <>Utilizziamo cookie per l'analisi e il miglioramento del sito (Google Analytics 4).{" "}
                  <Link to="/datenschutz" className="text-hb-yellow hover:underline">Informativa sulla privacy</Link></>
              : <>Wir verwenden Cookies für Analyse und Verbesserung der Website (Google Analytics 4).{" "}
                  <Link to="/datenschutz" className="text-hb-yellow hover:underline">Datenschutzerklärung</Link></>
            }
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            data-testid="cookie-decline-btn"
            className="text-xs text-white/40 hover:text-white/70 transition-colors font-inter px-4 py-2 border border-white/10 hover:border-white/20"
          >
            {lang === 'it' ? 'Solo necessari' : 'Nur notwendige'}
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="btn-primary text-xs px-6 py-2"
          >
            {lang === 'it' ? 'Accetta tutti' : 'Alle akzeptieren'}
          </button>
          <button
            onClick={decline}
            className="text-white/30 hover:text-white/60 transition-colors ml-1"
            aria-label={lang === 'it' ? 'Chiudi' : 'Schließen'}
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
